// extracted by mini-css-extract-plugin
export default {"container":"Landing_container__G3QLu"};